import { TextField } from 'mui-rff';
import React from 'react';

import IntegerField from '@dashboard/components/form/fields/IntegerField';
import Link from '@dashboard/components/mui-atoms/Link';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { SleepTimeUnits } from '@dashboard/generated/wp/platform';
import { DeleteOutlined } from '@mui/icons-material';
import { IconButton, MenuItem, Stack, Typography } from '@mui/material';

import useStepDefinitionsMutator from '../../../useStepDefinitionsMutator';
import DisableStepCheckbox from '../components/DisableStepCheckbox';

type Props = {
  name: string;
  index: number;
};
export default function SleepSection({ index, name }: Props) {
  const { fields } = useStepDefinitionsMutator();
  const handleDelete = () => {
    fields.remove(index);
  };

  return (
    <BaseSettingCard
      title="Delay"
      actions={
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton onClick={handleDelete}>
            <DeleteOutlined fontSize="small" />
          </IconButton>
          <DisableStepCheckbox name={name} />
        </Stack>
      }
    >
      <Typography color="text.secondary">Wait for a specific amount of time before continuing.</Typography>

      <Stack direction="row" spacing={1} mt={2} mb={1}>
        <IntegerField name={`${name}.sleep.timeAmount`} size="small" sx={{ width: 128 }} />
        <TextField name={`${name}.sleep.timeUnit`} size="small" select>
          <MenuItem value={SleepTimeUnits.Seconds}>Seconds</MenuItem>
          <MenuItem value={SleepTimeUnits.Minutes}>Minutes</MenuItem>
          <MenuItem value={SleepTimeUnits.Hours}>Hours</MenuItem>
          <MenuItem value={SleepTimeUnits.Days}>Days</MenuItem>
          <MenuItem value={SleepTimeUnits.Weeks}>Weeks</MenuItem>
        </TextField>
      </Stack>

      <Typography variant="body2" color="text.secondary">
        You can cancel delayed workflows with a separate API call &mdash;{' '}
        <Link
          href="https://www.usewaypoint.com/docs/using-workflow-delays"
          target="_blank"
          color="inherit"
          underline="hover"
          fontWeight="fontWeightMedium"
        >
          learn more
        </Link>
      </Typography>
    </BaseSettingCard>
  );
}
